import Alert from "react-popup-alert";
import React, { useState } from "react";
import CleanupColl, { CleanupModel } from "../../firebase/CleanupsColl";
import { TOKEN_KEY } from "../../util/Auth";
import { createRandomId, getUserIdName } from "../../util/Util";
import { getIslandForCoordinate } from "../../util/UtilMap";
import MapComponent from "../../components/Map";
import CheckBoxComponent from "../../components/MultiSelector";
import { CleanupDebrisLog } from "../../components/cleanups/CleanupDebrisLog";
import Resizer from "react-image-file-resizer";
import { CleanupPhotoForm } from "../../components/cleanups/CleanupPhotoForm";
import { useHistory } from "react-router-dom";
import Fire from "../../firebase/Fire";
import UtilDate from "../../util/UtilDate";
import "../../static/css/Activities.css";
import firebase from "firebase/app";

import {
  ACTION,
  activityOptions,
  AFTER,
  BEFORE,
  ERR_TITLE,
  SEND_ADMIN_MSG_ERR,
  VOLUNTEERS,
  ORG_ID,
  ADMIN
} from "../../util/CommonConstants";

// CSS
import "react-popup-alert/dist/index.css";
import MessagesUserColl from "../../firebase/MessagesUserColl";
import Footer from "../../components/Footer";

export const CleanupLogForm = (props) => {
  const history = useHistory();
  const [cleanupSite, setCleanupSite] = useState("");
  const [numberOfVolunteers, setNumberOfVolunteers] = useState(0);
  const [numberOfVisitors, setNumberOfVisitors] = useState(0);
  const [numberOfHours, setNumberOfHours] = useState(0);
  const [groupName, setGroupName] = useState("");
  const [distanceTravelled, setDistanceTravelled] = useState(0);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [debrisRecords, setDebrisRecords] = useState([]);
  const [cleanupNotes, setCleanupNotes] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [photoMap, setPhotoMap] = useState(
    new Map([
      [BEFORE, null],
      [AFTER, null],
      [ACTION, null],
      [VOLUNTEERS, null]
    ])
  );

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [alert, setAlert] = React.useState({
    type: "error",
    text: "This is a alert message",
    show: false
  });

  function onCloseAlert() {
    setAlert({
      type: "",
      text: "",
      show: false
    });
  }

  function onShowAlert(type, text) {
    setAlert({
      type: type,
      text: text,
      show: true
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Check email verification
    const user = firebase.auth().currentUser;
    if (!user || !user.emailVerified) {
      onShowAlert(
        "error",
        "Please verify your email address before submitting a cleanup. Check your inbox for the verification email."
      );
      setIsLoading(false);
      return;
    }

    let userInfo = JSON.parse(localStorage.getItem(TOKEN_KEY));
    let siteId = cleanupSite
      .replace(/\s/g, "")
      .replace(/\//g, "")
      .substring(0, 10);
    let userIdName = getUserIdName(userInfo.id);

    // create cleanup object
    let cleanup = new CleanupModel();

    if (!userInfo) {
      onShowAlert(
        "error",
        "Failed to find user info. Please log out and log back in."
      );
      setIsLoading(false);
      return;
    }
    cleanup.id = userIdName + "_" + siteId + "_" + createRandomId();
    cleanup.user_id = userInfo.id;
    cleanup.user_name = userInfo.display_name;

    cleanup.organization = localStorage.getItem(ORG_ID);

    if (!latitude || !longitude) {
      onShowAlert(
        "error",
        "Please specify the location of the cleanup by clicking on the map."
      );
      setIsLoading(false);
      return;
    }
    cleanup.island = getIslandForCoordinate(latitude, longitude);
    cleanup.geolocation = {
      lat: latitude,
      long: longitude
    };

    if (!cleanupSite) {
      onShowAlert("error", "Cleanup site name required.");
      setIsLoading(false);
      return;
    }
    cleanup.site_name = cleanupSite;
    cleanup.start_date = new Date();
    cleanup.create_date = new Date();
    cleanup.last_update_date = new Date();

    if (!numberOfHours) {
      onShowAlert("error", "Number of cleanup hours required.");
      setIsLoading(false);
      return;
    }
    cleanup.total_time = parseFloat(numberOfHours);
    cleanup.distance = parseFloat(distanceTravelled);
    cleanup.num_volunteers = parseInt(numberOfVolunteers);
    cleanup.num_visitors = parseInt(numberOfVisitors);
    if (numberOfVolunteers > 0) {
      cleanup.group_name = groupName;
      if (numberOfVisitors > numberOfVolunteers) {
        onShowAlert(
          "error",
          "Number of visitors cannot be greater than number of volunteers."
        );
        setIsLoading(false);
        return;
      }
    }
    cleanup.activities = selectedActivities;
    cleanup.debris_list = debrisRecords;
    cleanup.notes = cleanupNotes;

    let photoURIs = await savePhotos(cleanup.id);
    if (photoURIs) {
      if (photoURIs.has(BEFORE)) {
        cleanup.photo_before_uri = photoURIs.get(BEFORE);
      }
      if (photoURIs.has(AFTER)) {
        cleanup.photo_after_uri = photoURIs.get(AFTER);
      }
      if (photoURIs.has(ACTION)) {
        cleanup.photo_action_uri = photoURIs.get(ACTION);
      }
      if (photoURIs.has(VOLUNTEERS)) {
        cleanup.photo_volunteers_uri = photoURIs.get(VOLUNTEERS);
      }
    }

    let success = await CleanupColl.shared.createCleanup(cleanup, false);

    // send organizer message
    let message =
      "This is an auto-generated notification for cleanup approval. This request was submitted through the Web App, so the user may respond through email/SMS instead of the Mobile App.";
    message += "\n\nName: " + userInfo.first_name + " " + userInfo.last_name;
    message += "\nEmail: " + userInfo.email;
    message += "\nPhone #: " + userInfo.phone;
    message += "\n\nOrganization: " + cleanup.organization;

    message += "\n\nCleanup recorded at site: " + cleanup.site_name;
    message += "\nGo to admin screen to approve or delete cleanup.";
    console.log(message);
    let firestoreMessage =
      await MessagesUserColl.shared.createIndividualMessage(
        {
          message: message,
          subject: "Cleanup Needs Approval"
        },
        ADMIN
      );

    if (!firestoreMessage) {
      alert(ERR_TITLE, SEND_ADMIN_MSG_ERR);
      setIsLoading(false);
      return;
    }

    if (success) {
      history.push("/cleanup/complete");
    } else {
      onShowAlert(
        "error",
        "Failed to save cleanup data, please double check fields and try again. If the issue persists, contact 808cleanupsapp@gmail.com for assistance."
      );
    }
    setIsLoading(false);
  };

  const updatePhotoMap = async (photoType, file) => {
    console.log(photoType, file);
    let pMap = photoMap;
    let resizedImageFile = await resizeFile(file);
    pMap.set(photoType, resizedImageFile);
    setPhotoMap(pMap);
    console.log(photoMap);
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        800,
        800,
        "JPEG",
        100,
        0,
        (file) => {
          console.log(file);
          resolve(file);
        },
        "file"
      );
    });

  const savePhotos = async (cleanupID) => {
    const today = new Date();
    const mo = UtilDate.getMonthValue(today.getMonth());
    const year = today.getFullYear();

    try {
      let photoUploadMap = await Fire.shared.uploadMultiplePhotos(
        `cleanup/${year}/${mo}/cleanupPhoto_${cleanupID}`,
        photoMap
      );
      return photoUploadMap;
    } catch (error) {
      console.log(error);
    }
    return null;
  };

  const handleSelectedActivities = (event) => {
    const value = event.target.value;
    if (selectedActivities.includes(value)) {
      setSelectedActivities(
        selectedActivities.filter((item) => item !== value)
      );
    } else {
      setSelectedActivities([...selectedActivities, value]);
    }
  };

  const handleLocationUpdate = (lat, long) => {
    console.log(lat, long);
    setLatitude(lat);
    setLongitude(long);
  };

  return (
    <div
      style={{
        minHeight: "100vh"
      }}
    >
      <h1>🌊 Log Your Cleanup</h1>
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "40px",
          marginBottom: "40px"
        }}
      >
        {/* Progress Indicator */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "30px",
            padding: "0 20px"
          }}
        >
          {[
            { label: "1. Location", icon: "📍" },
            { label: "2. Debris Details", icon: "📋" },
            { label: "3. Photos", icon: "📸" },
            { label: "4. Submit", icon: "✅" }
          ].map((step, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 1
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#e3f2fd",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  marginBottom: "8px"
                }}
              >
                {step.icon}
              </div>
              <span
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  textAlign: "center"
                }}
              >
                {step.label}
              </span>
            </div>
          ))}
        </div>

        {/* Form Sections */}
        <form onSubmit={handleSubmit}>
          {/* Section 1: Basic Information */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              📍 Basic Information
            </h3>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Cleanup Site Name *
              </label>
              <input
                type="text"
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  fontSize: "16px",
                  transition: "border-color 0.3s ease"
                }}
                value={cleanupSite}
                onChange={(e) => setCleanupSite(e.target.value)}
                placeholder="Enter the name of the cleanup location"
                required
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Mark cleanup location on the map *
              </label>
              <div
                style={{
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  overflow: "hidden"
                }}
              >
                <MapComponent handleLocationUpdate={handleLocationUpdate} />
              </div>
              {latitude && longitude && (
                <p
                  style={{
                    marginTop: "8px",
                    fontSize: "14px",
                    color: "#28a745",
                    fontWeight: "500"
                  }}
                >
                  ✅ Location selected: {latitude.toFixed(4)},{" "}
                  {longitude.toFixed(4)}
                </p>
              )}
            </div>
          </div>

          {/* Section 2: Cleanup Details */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              📋 Cleanup Details
            </h3>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
                marginBottom: "20px"
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057"
                  }}
                >
                  Number of Additional Volunteers
                </label>
                <input
                  type="number"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e9ecef",
                    borderRadius: "6px",
                    fontSize: "16px"
                  }}
                  value={numberOfVolunteers}
                  onChange={(e) => setNumberOfVolunteers(e.target.value)}
                  placeholder="0"
                  min="0"
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057"
                  }}
                >
                  Number of Hours *
                </label>
                <input
                  type="number"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e9ecef",
                    borderRadius: "6px",
                    fontSize: "16px"
                  }}
                  value={numberOfHours}
                  onChange={(e) => setNumberOfHours(e.target.value)}
                  placeholder="0"
                  min="0"
                  step="0.5"
                  required
                />
              </div>
            </div>

            {numberOfVolunteers > 0 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginBottom: "20px"
                }}
              >
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#495057"
                    }}
                  >
                    Group Name *
                  </label>
                  <input
                    type="text"
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "2px solid #e9ecef",
                      borderRadius: "6px",
                      fontSize: "16px"
                    }}
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder="Enter group name"
                    required
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#495057"
                    }}
                  >
                    Number of Visitors (Non-Residents)
                  </label>
                  <input
                    type="number"
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "2px solid #e9ecef",
                      borderRadius: "6px",
                      fontSize: "16px"
                    }}
                    value={numberOfVisitors}
                    onChange={(e) => setNumberOfVisitors(e.target.value)}
                    placeholder="0"
                    min="0"
                  />
                </div>
              </div>
            )}

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Distance Travelled (miles)
              </label>
              <input
                type="number"
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  padding: "12px",
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  fontSize: "16px"
                }}
                value={distanceTravelled}
                onChange={(e) => setDistanceTravelled(e.target.value)}
                placeholder="0"
                min="0"
                step="0.1"
              />
            </div>
          </div>

          {/* Section 3: Activities */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              🏃‍♂️ Activities Performed
            </h3>
            <CheckBoxComponent
              handleCheckBoxChange={handleSelectedActivities}
              items={activityOptions}
              selectedItems={selectedActivities}
            />
          </div>

          {/* Section 4: Debris Log */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              🗑️ Debris Collected
            </h3>
            <CleanupDebrisLog updateRecordList={setDebrisRecords} />
          </div>

          {/* Section 5: Notes */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              📝 Cleanup Notes
            </h3>
            <textarea
              style={{
                width: "100%",
                padding: "12px",
                border: "2px solid #e9ecef",
                borderRadius: "6px",
                fontSize: "16px",
                minHeight: "120px",
                resize: "vertical"
              }}
              value={cleanupNotes}
              onChange={(e) => setCleanupNotes(e.target.value)}
              placeholder="Share details about your cleanup experience, challenges encountered, or any other relevant information..."
            />
          </div>

          {/* Section 6: Photos */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "30px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              📸 Photos (Optional)
            </h3>
            <CleanupPhotoForm updatePhotoMapFunction={updatePhotoMap} />
          </div>

          {/* Submit Section */}
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              backgroundColor: "#e3f2fd",
              borderRadius: "8px",
              marginBottom: "20px"
            }}
          >
            <button
              type="submit"
              disabled={isLoading}
              style={{
                backgroundColor: isLoading ? "#6c757d" : "#2c5aa0",
                color: "white",
                border: "none",
                padding: "15px 40px",
                borderRadius: "8px",
                fontSize: "18px",
                fontWeight: "600",
                cursor: isLoading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
              onMouseEnter={(e) => {
                if (!isLoading) {
                  e.target.style.backgroundColor = "#1e3a8a";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isLoading) {
                  e.target.style.backgroundColor = "#2c5aa0";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                }
              }}
            >
              {isLoading ? (
                <span>
                  <span style={{ marginRight: "8px" }}>⏳</span>
                  Saving Cleanup...
                </span>
              ) : (
                <span>Submit Cleanup</span>
              )}
            </button>
          </div>
        </form>

        <Alert
          header={"Error"}
          btnText={"Close"}
          text={alert.text}
          type={alert.type}
          show={alert.show}
          onClosePress={onCloseAlert}
          pressCloseOnOutsideClick={true}
          showBorderBottom={true}
        />
      </div>
      <Footer />
    </div>
  );
};
